import { Flex, Button } from '@servicetitan/anvil2';
import { WorkflowButtonsStore } from '@servicetitan/financing-workflow-shared';

interface ButtonsProps {
    onBack?: () => void;
    onContinue?: () => void;
    hideContinueButton?: boolean;
    isLoading?: boolean;
}

export const Buttons = ({ onBack, onContinue, hideContinueButton, isLoading }: ButtonsProps) => {
    const { CancelApplicationButton } = WorkflowButtonsStore.useStore();

    return (
        <Flex
            justifyContent={onBack ? 'space-between' : 'flex-end'}
            style={{
                width: '100%',
                paddingBottom: '24px',
                paddingTop: '16px',
                marginTop: 'auto',
                position: 'sticky',
                bottom: 0,
                backgroundColor: 'var(--a2-background-color-default, #ffffff)',
                zIndex: 1,
            }}
        >
            {onBack && (
                <Button appearance="secondary" onClick={onBack}>
                    Back
                </Button>
            )}
            <Flex gap="3" justifyContent="flex-end">
                <CancelApplicationButton>Cancel</CancelApplicationButton>
                {!hideContinueButton && (
                    <Button appearance="primary" onClick={onContinue} loading={isLoading}>
                        Continue
                    </Button>
                )}
            </Flex>
        </Flex>
    );
};
